import './index.scss'

$(document).ready(function(){
  //选择
  $('.select-cont .select-all a').addClass('active')

  $('.select-cont .select-option a').on('click',function(){
    let $parentsEl = $(this).parents('.select-cont')
    let data = $(this).html()
    $parentsEl.find('.select-all a').removeClass('active')
    $(this).addClass('active').siblings().removeClass('active')
  })

  $('.select-cont .select-all a').on('click',function(){
    $(this).addClass('active')
    let $parentsEl = $(this).parents('.select-cont')
    $parentsEl.find('.select-option a').removeClass('active')
  })

  //列表
  $('.section2 .cont .cont-list').on('click','.cont-item .item-title',function(){
    let $parentsEl = $(this).parents('.cont-item')
    if($parentsEl.hasClass('active')){
      if($(window).width()>767){
        $parentsEl.removeClass('active').find('.item-desc').slideUp()
      }else{
        $parentsEl.removeClass('active')
        $('.job-mask').fadeOut(400)
      }
    }else{
      if($(window).width()>767){
        $parentsEl.addClass('active').find('.item-desc').slideDown()
        $parentsEl.siblings().removeClass('active').find('.item-desc').slideUp()
      }else{
        $parentsEl.addClass('active')
        $('.job-mask').fadeIn(400)
      }
    }
  })
  $('.section2 .cont .cont-list').on('click','.mob-title .close-btn',function(){
    console.log(11)
    let $parentsEl = $(this).parents('.cont-item')
    $parentsEl.removeClass('active')
    $('.job-mask').fadeOut(400)
  })

  // 移动端显示选择项
  $('.job-mob-banner .show-select').on('click',function(){
    $('.section1').addClass('active')
    $('.job-mask').fadeIn(400)
  })
  $('.section1 .mob-btn >div').on('click',function(){
    $('.section1').removeClass('active')
    $('.job-mask').fadeOut(400)
  })
  $('.job-mask').on('click',function(){
    $('.section1').removeClass('active')
    $('.section2 .cont .cont-list .cont-item').removeClass('active')
    $('.job-mask').fadeOut(400)
  })
})
